import React from "react";
import "./footer.css";
import Wave from "../image/wave.jpg";
import Insta from "@iconscout/react-unicons/icons/uil-instagram"
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";
// import linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
// import linkedin from "@iconscout/react-unicons/icons/uil-linkedin-alt"

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" ,height:"250px"}} />
      <div className="f-content">
        <span>aman004dubey@gmail.com</span>
        <div className="f-icons">
       <a href="https://www.instagram.com/aman_anshul/"><Insta color="white" size={"3rem"} /></a>   
        <a href="https://www.facebook.com/aman.dubey.1422"><Facebook color="white" size={"3rem"} /></a>  
       <a href="https://github.com/amananshul"><Gitub color="white" size={"3rem"} /></a>   
       {/* <a href="https://www.linkedin.com/in/aman-dubey-65170920b/"><linkedin color="white" size={"3rem"} /></a>  */}
       

        </div>
      </div>
    </div>
  );
};

export default Footer;